export default __webpack_public_path__ + "static/Experience-5376fab5d8e52318c87d756d834d47bd.webp";